import { safeNum } from '../extractors/_shared';
const buildJ = (emoji, zh, en, positive) => ({ emoji, labelZh: zh, labelEn: en, positive });

/** sentiment 范围 -1 ~ 1 */
export function judgeSentiment(s) {
  const v = safeNum(s);
  if (v == null) return null;
  if (v >  0.5)  return buildJ('🚀', '强烈正面',  'Strongly positive', true);
  if (v >  0.1)  return buildJ('🟢', '正面',      'Positive',          true);
  if (v > -0.1)  return buildJ('⚪️', '中性',      'Neutral',           null);
  if (v > -0.5)  return buildJ('🟡', '偏负面',    'Slightly negative', false);
  return            buildJ('🔴', '强烈负面',  'Strongly negative', false);
}
